// extracted by css-extract-rspack-plugin
export default {"cls1":"Base-cls1__tH","cls2":"Base-cls2_gaY Base-cls1__tH"};